<template>
  <layout>
    <h1>{{ $t('pages.request.title') }}</h1>
    <p>{{ $t('pages.request.explain') }}</p>
    <request-form :success_route="{ name: 'home' }" uri="api/public/resetting/request" />
  </layout>
</template>

<script>
  import Layout from '@/views/Default/Layout';
  import RequestForm from '@triotech/vue-core/src/components/authentification/AjaxRequest';

  export default {
    name: 'RequestPage',
    components: {
      RequestForm,
      Layout,
    },
    mounted() {
      this.$bus.$emit('t-event.t-modal.sign-in-sign-up-modal.close');
    },
  };
</script>



// WEBPACK FOOTER //
// src/views/Authentification/request.vue